<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/daily/remind/index' }">备忘录</el-breadcrumb-item>
      <el-breadcrumb-item>{{ form.id <= 0 ? '添加' : '编辑'}}备忘录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :model="form" ref="ruleForm" :rules="rules" label-width="160px">
          <el-form-item label="标题" prop="title">
            <el-col :span="12">
              <el-input size="small" v-model="form.title" placeholder="请输入标题"></el-input>
            </el-col>
          </el-form-item>
          
          <el-form-item label="内容" prop="content">
            <el-col :span="12">
              <el-input type="textarea" v-model="form.content" placeholder="请输入内容"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="是否调度" prop="status">
            <el-col :span="12">
              <el-switch
                v-model="form.status"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-col>
          </el-form-item>

          <el-form-item label="调度计划" prop="plan" v-if="form.status == 1">
            <el-col :span="12">
              <el-input size="small" v-model="form.plan" placeholder="请输入调度计划，corntab形式"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        id: '',
        title: '',
        content: '',
        plan: '',
        status: 0,
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 1, max: 255, message: '标题长度在1到255个字符', trigger: 'blur' }
        ],
        content: [
          {  required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 255, message: '内容长度在1到255个字符', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    loadRemind() {
      var id = this.$route.query ? this.$route.query.id : 0;
      if(!id) {
        return 0
      }

      this.$ajax({
        url: "/daily/remind/one?id=" + id,
        type:"GET",
      }).then(res => {
        this.form = {
          id: res.data.id,
          title: res.data.title,
          content: res.data.content,
          plan: res.data.plan,
          status: res.data.status,
        }
      });
    },
    save() {
      let form = this.form;
      this.$refs.ruleForm.validate((valid) => {
        if(!valid) {
          return false;
        }

        // 开始处理loading.
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          type: 'POST',
          url: '/daily/remind/save',
          data: form,
        }).then((res) => {
          loading.close()
          if(res.code != 200) {
            return this.$util.msg(res.msg, "error");
          }
          
          this.$util.msg(res.msg, "success");

          setTimeout(() => {
            this.$router.push({ path: "/daily/remind/index" });
          });
        })
      });

      return false;
    }
  },
  mounted() {
    this.loadRemind()
  }
};
</script>
<style>
</style>